import { Medico } from "../medico/medico";

export class FaltaMedica {

    id: number = 0;

    medico: Medico = new Medico();

    dataFalta: Date = new Date();

    horaFalta: string = '';

    faltaDiaInteiro: boolean = false;
    
    faltaPeriodoManha: boolean = false;
    
    faltaPeriodoTarde: boolean = false;

    motivoFalta: string = '';

    constructor() {
    }
}
